import { safeLocalStorage } from '../utils/safeStorage';
const SELENIUM_ONBOARDING_BEACONS_FLAG = 'selenium_onboarding_beacons_enabled';
const SELENIUM_ONBOARDING_BEACONS_CONFIG = 'selenium_onboarding_beacons_config';
export const setOnboardingBeaconsConfigForSelenium = beaconsConfig => {
  if (safeLocalStorage.getItem(SELENIUM_ONBOARDING_BEACONS_FLAG) === 'true') {
    safeLocalStorage.setItem(SELENIUM_ONBOARDING_BEACONS_CONFIG, JSON.stringify(beaconsConfig,
    // convert functions to strings to prevent them from being excluded from the config
    (__key, value) => typeof value === 'function' ? 'function' : value));
  }
};
export const clearOnboardingBeaconsConfigForSelenium = () => {
  safeLocalStorage.removeItem(SELENIUM_ONBOARDING_BEACONS_CONFIG);
};
const SELENIUM_DISABLE_ONBOARDING_BEACONS_KEY = 'selenium.disable.onboarding_beacons';
export const shouldDisableOnboardingBeacons = () => {
  return (
    // Use the convention selenium.disable.<feature>.
    // selenium.disable.onboarding_beacons = 'true' should prevent the Beacons from loading.
    safeLocalStorage.getItem(SELENIUM_DISABLE_ONBOARDING_BEACONS_KEY) === 'true'
  );
};